module.exports = __webpack_public_path__ + "img/contact.4b81d91c.jpg";